import jQuery from 'jquery';
window.jQuery = jQuery;
window.$ = jQuery;
export { jQuery, jQuery as $ };
